import { render, staticRenderFns } from "./TransactionsSummary.vue?vue&type=template&id=55b47a74&scoped=true"
import script from "./TransactionsSummary.vue?vue&type=script&lang=js"
export * from "./TransactionsSummary.vue?vue&type=script&lang=js"
import style0 from "./TransactionsSummary.vue?vue&type=style&index=0&id=55b47a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b47a74",
  null
  
)

export default component.exports